import React from 'react';

const PageHeading = ({ title }) => {
    return (
        <>
            {/* <div className='bg-primary text-white px-12 max-md:px-10 py-2 font-[500] text-[16px] rounded-md flex items-center justify-center self-start text-nowrap'>{title}</div> */}
            <div className='border-l-4 border-primary pl-2 text-nowrap text-lg font-medium self-center capitalize'>{title}</div>
        </>
    )
}

export default PageHeading;